let sessionExpiredHandler = null;

export const AUTH_TOKEN_HEADER = "X-Auth-Token";
export const AUTH_TOKEN_REFRESHED_EVENT = "storefront:auth-token-refreshed";

export function setSessionExpiredHandler(handler) {
    sessionExpiredHandler = handler;
}

export function notifySessionExpired() {
    sessionExpiredHandler?.();
}

/** Persist a slid JWT from the API and notify {@link AuthProvider}. */
export function applyRefreshedAuthToken(token) {
    if (!token) {
        return;
    }
    localStorage.setItem("token", token);
    window.dispatchEvent(new CustomEvent(AUTH_TOKEN_REFRESHED_EVENT, { detail: token }));
}

export function captureAuthTokenFromResponse(response) {
    if (!response?.headers) {
        return;
    }
    const next = response.headers.get(AUTH_TOKEN_HEADER);
    if (next) {
        applyRefreshedAuthToken(next);
    }
}
